import PropTypes from 'prop-types'
import React from 'react'
import focusable from '../../components/Focusable/Focusable'
import Spinner from '../../components/Spinner/Spinner'
import tts from '../../lib/TTS'
import Video from '../Video/Video'
import FocusableDiv from '../../components/FocusableDiv/FocusableDiv'
import {
  platformTransitionStyle,
  secondsToTTS,
} from '../../../../shared/helpers.js'

class VideoList extends React.Component {
  constructor(props) {
    super(props)
    this.componentType = 'videoList'
    this.headerHeight = 0
    this.videoRefs = []
    this.activeVideoIndex = 0
    this.sectionsInformation = []
    this.totalEpisodes = 0

    this.state = {
      offset: 0,
      endingPoint: 3,
    }

    this.emptySetMessageRef = React.createRef()
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.videoListFocus !== prevProps.videoListFocus &&
      this.props.videoListFocus
    ) {
      if (
        !this.props.videoSections[0]?.hasVideos ||
        this.props.videoSections[0]?.videos.length === 0
      ) {
        tts.addTextToRead(
          `No episodes are currently available for this season.`
        )
      } else {
        this.readSeasonVideos(this.activeVideoIndex)
      }
    }
  }

  componentDidMount() {
    if (this.props.videoSections.length > 0) {
      let ttsSeasonInformationContentArray = []

      this.props.seasonDescription &&
        ttsSeasonInformationContentArray.push(this.props.seasonDescription)
      let ttsSectionInformation = []

      this.sectionsInformation = this.props.videoSections
        .filter((videoSection) => {
          return videoSection.hasVideos && videoSection
        })
        .map((videoSection) => {
          ttsSectionInformation.push(
            `${videoSection.videos.length} ${videoSection.type}`
          )

          return {
            type: videoSection.type,
            'section-length': videoSection.videos.length,
          }
        })

      this.totalEpisodes = this.sectionsInformation.reduce(function (acc, obj) {
        return acc + obj['section-length']
      }, 0)

      if (ttsSectionInformation.length > 1) {
        ttsSectionInformation = ttsSectionInformation.join(' and ')
      }

      if (ttsSectionInformation.length === 1) {
        ttsSectionInformation = ttsSectionInformation.join('')
      }
      ttsSeasonInformationContentArray.push(`it has ${ttsSectionInformation}`)

      const reversedArray = ttsSeasonInformationContentArray.reverse()
      this.props.onReadText && this.props.onReadText(reversedArray)
    } else {
      tts.addTextToRead(`No episodes are currently available for this season.`)
    }
  }

  onKeyEvent(key) {
    let handled = false
    let focusedComponent = window.focusedComponent
    let noSeasons =
      !this.props.videoSections[0]?.hasVideos ||
      this.props.videoSections[0]?.videos.length === 0
    let noExtras =
      !this.props.videoSections[1]?.hasVideos ||
      this.props.videoSections[1]?.videos.length === 0
    if (focusedComponent.componentType) {
      if ('video' === focusedComponent.componentType) {
        let endingPoint = this.state.endingPoint
        if ('DOWN' === key) {
          tts.stopRead()
          // Only one entry, return early
          if (this.videoRefs.length === 0) {
            return true
          }
          //check # of episodes or extras if episodes is empty
          let numberOfVideos = 0
          if (this.props.videoSections[0]) {
            numberOfVideos += this.props.videoSections[0]?.videos.length
          }
          if (this.props.videoSections[1]) {
            numberOfVideos += this.props.videoSections[1]?.videos.length
          }

          endingPoint =
            endingPoint < numberOfVideos ? endingPoint + 1 : numberOfVideos

          this.setState({ endingPoint })

          // Check if we're at the end
          if (this.activeVideoIndex < this.videoRefs.length - 1) {
            this.navigate(key)
            handled = true
          } else {
            if (noExtras) {
              this.handleNavigationFromEmptySet()
              this.activeVideoIndex++
            }
            handled = true
          }
        }

        if ('UP' === key) {
          tts.stopRead()
          // Only one entry, early return
          if (this.videoRefs.length === 0) {
            return true
          }

          // Check if we're at the start
          if (this.activeVideoIndex !== 0) {
            this.navigate(key)
            handled = true
          } else {
            if (noSeasons) {
              this.handleNavigationFromEmptySet()
            }
            handled = true
          }
        }

        if ('LEFT' === key) {
          tts.stopRead()
          this.navigate(key)
          this.setState({ endingPoint: 3 })
        }

        if ('RIGHT' === key) {
          handled = true
        }
      }

      if ('emptySet' === focusedComponent.componentType) {
        if ('BACK' === key) {
          this.props?.parent?.props?.history?.goBack()
          handled = false
        }
        if ('LEFT' === key) {
          tts.stopRead()
          this.navigate(key)
          this.setState({ endingPoint: 3 })
        }

        if ('UP' === key) {
          if (noSeasons) {
            //noop
          } else {
            this.navigate(key)
          }
          handled = true
        }

        if (noSeasons) {
          if ('DOWN' === key) {
            this.activeVideoIndex--
            this.navigate(key)
          }
          handled = true
        }
      }
    }

    return handled
  }

  handleNavigationFromEmptySet() {
    let type =
      !this.props.videoSections[0]?.hasVideos ||
      this.props.videoSections[0]?.videos.length === 0
        ? 'episodes'
        : !this.props.videoSections[1]?.hasVideos ||
          this.props.videoSections[1]?.videos.length === 0
        ? 'extras'
        : ''
    this.emptySetMessageRef.current?.setFocus()
    tts.addTextToRead(`No ${type} are currently available for this season.`)
  }

  setChildFocus() {
    if (
      !this.props.videoSections[0]?.hasVideos ||
      this.props.videoSections[0]?.videos.length === 0
    ) {
      this.emptySetMessageRef.current?.setFocus()
    } else {
      this.videoRefs[this.activeVideoIndex]?.setFocus()
    }
  }

  setVideoRef(video, i) {
    if (video) {
      // If i === 0 we're setting new refs, so reset the array
      if (i === 0) {
        this.videoRefs = []
      }
      this.videoRefs[i] = video
    }
  }

  navigate(direction) {
    let height
    if (
      this.videoRefs[this.activeVideoIndex]?.instance?.videoLinkRef?.current ===
      null
    ) {
      return
    } else {
      height =
        this.videoRefs[
          this.activeVideoIndex
        ]?.instance?.videoLinkRef?.current?.getBoundingClientRect()?.height ||
        this.emptySetMessageRef.current?.instance?.focusableDivRef?.current?.getBoundingClientRect()
          ?.height
    }

    let offset = this.state.offset

    switch (direction) {
      case 'UP':
        offset -= height
        this.activeVideoIndex--
        this.readSeasonVideos(this.activeVideoIndex, 'UP')
        this.videoRefs[this.activeVideoIndex]?.setFocus()
        break
      case 'DOWN':
        offset += height
        this.activeVideoIndex++
        this.readSeasonVideos(this.activeVideoIndex, 'DOWN')
        this.videoRefs[this.activeVideoIndex]?.setFocus()
        break
      case 'LEFT':
        offset = 0
        this.activeVideoIndex = 0
        if (
          !this.props.videoSections[0]?.hasVideos ||
          this.props.videoSections[0]?.videos.length === 0
        ) {
          this.props?.parent?.buttonRefs[
            this.props?.parent?.activeButtonIndex
          ]?.setFocus()
        } else {
          this.videoRefs[this.activeVideoIndex]?.setFocus()
        }
        break
      default:
        offset = 0
        this.videoRefs[this.activeVideoIndex]?.setFocus()
        break
    }

    this.setState({
      offset,
    })
  }

  readSeasonVideos(idx, direction = 'DOWN') {
    const videoProps = this.videoRefs[idx]?.props?.video
    const videoPropsParent = videoProps?.parent

    const title = videoProps?.title
    const description_short = videoProps?.description_short
    const video_type = videoProps?.video_type
    const duration = videoProps?.duration

    const seasonResourceType = videoPropsParent?.season?.resource_type
    const seasonOrdinal = videoPropsParent?.season?.ordinal
    const resource_type = videoPropsParent?.resource_type
    const ordinal = videoPropsParent?.ordinal

    const lastEspisodeIndex = this.props.videoSections[0]?.videos.length - 1

    if (direction === 'DOWN' && idx === lastEspisodeIndex + 1) {
      tts.pushTextToRead('Extra Section')
    }

    if (direction === 'UP' && idx === lastEspisodeIndex) {
      tts.pushTextToRead('Episodes Section')
    }

    tts.addTextToRead([
      `Focused on ${idx + 1} of ${this.totalEpisodes}`,
      title,
      'full_length' !== video_type && video_type ? video_type : '',
      seasonResourceType ? seasonResourceType : '',
      seasonOrdinal ? `${seasonOrdinal}` : '',
      resource_type ? resource_type : '',
      ordinal ? `${ordinal}` : '',
      secondsToTTS(`${duration}`),
      description_short,
    ])
  }

  render() {
    const {
      spinnerVisible,
      videoSections,
      activeSeason,
      seasonShowTitle,
      seasonDescription,
    } = this.props

    let titleText = ''
    if (activeSeason) {
      if (seasonShowTitle.length > 0) {
        titleText = `Season ${activeSeason}: ${seasonShowTitle}`
      } else {
        titleText = `Season ${activeSeason}`
      }
    } else {
      titleText = 'More Extras'
    }

    const { offset } = this.state

    if (!videoSections || videoSections.length === 0) {
      return null
    } else {
      const firstSectionLength = videoSections[0]?.videos?.length
      return (
        <div
          className="video-list-container"
          style={{
            transition: platformTransitionStyle('transform 0.25s'),
            transform: `translate(0px, -${offset}px)`,
            paddingBottom: `${offset * 5}px`,
          }}
        >
          <h3 className="video-list-title">
            {titleText}
            {seasonDescription && (
              <div className="video-list-description">{seasonDescription}</div>
            )}
          </h3>

          {videoSections.map((section, i) => {
            return (
              <div key={`${section.type}-${i}`}>
                <p className="content-label">{section.type}</p>
                <Spinner visible={spinnerVisible} mini={true} />
                {!spinnerVisible &&
                  section.hasVideos &&
                  section.videos
                    .slice(0, this.state.endingPoint)
                    .map((video, j) => {
                      let counter = j
                      if (i === 1) {
                        counter = j + firstSectionLength
                      }
                      return (
                        <Video
                          sectionType={section.type}
                          parent={this}
                          key={j}
                          video={video}
                          ref={(video) => {
                            this.setVideoRef(video, counter)
                          }}
                        />
                      )
                    })}
                {(!spinnerVisible && !section.hasVideos) ||
                section.videos.length === 0 ? (
                  <FocusableDiv
                    parent={this}
                    className="empty-list"
                    ref={this.emptySetMessageRef}
                    componentType="emptySet"
                  >
                    No {section.type} are currently available for this season.
                  </FocusableDiv>
                ) : null}
              </div>
            )
          })}
        </div>
      )
    }
  }
}

VideoList.propTypes = {
  // activeSeason is a number but is being used in a string - added union type here
  activeSeason: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  seasonDescription: PropTypes.string,
  seasonShowTitle: PropTypes.string,
  spinnerVisible: PropTypes.bool,
  videoSections: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  videoListFocus: PropTypes.bool,
  onReadText: PropTypes.func,
  parent: PropTypes.shape({
    buttonRefs: PropTypes.array,
    activeButtonIndex: PropTypes.number,
    props: PropTypes.shape({
      history: PropTypes.shape({
        goBack: PropTypes.func,
      }),
    }),
  }),
}

export default focusable(VideoList)
